import { render } from "./ToggleButton.vue?vue&type=template&id=37875e54&scoped=true"
import script from "./ToggleButton.vue?vue&type=script&lang=js"
export * from "./ToggleButton.vue?vue&type=script&lang=js"

import "./ToggleButton.vue?vue&type=style&index=0&id=37875e54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37875e54"],['__file',"src/components/ToggleButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37875e54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37875e54', __exports__)) {
    api.reload('37875e54', __exports__)
  }
  
  module.hot.accept("./ToggleButton.vue?vue&type=template&id=37875e54&scoped=true", () => {
    api.rerender('37875e54', render)
  })

}


export default __exports__